import { fetchRetryParameters, requestHostHeaders } from '~/composables/constants/api'
import type { RequestHostHeadersType } from '~/composables/constants/api'
import { getRequestHost, H3Event } from 'h3'

import type { Language } from '~/types/storeTypes'

export default async function (event?: H3Event) {
  return await $fetch<Pick<Language, 'id' | 'iso_code'>[]>('/api/config/languages', {
    ...fetchRetryParameters,
    ...(event
      ? {
          headers: {
            host: getRequestHost(event, {
              xForwardedHost: true,
            }),
          },
        }
      : {
          headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
        }),
  })
}
